import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Component, OnInit ,ViewEncapsulation} from '@angular/core';
import { DocumentData } from 'firebase/firestore';
import { FirebaseCrudService } from '../services/firebase-crud.service';
import { Subscription } from 'rxjs';
import { MatTabsModule } from '@angular/material/tabs';
import { FoodType } from '../models/foodtype.model';
import { MarriageMenuService } from '../marriagemenu/marriagemenu.service';
import { MatOptgroup, MatOption, MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatIcon } from '@angular/material/icon';
import { MatDialog } from '@angular/material/dialog';
import { PasswordGuardDialogComponent } from './password-guard-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { firstValueFrom } from 'rxjs';
import { RouterModule } from '@angular/router';
import { Router } from '@angular/router';



@Component({
  selector: 'app-admin-page',
  imports: [FormsModule,CommonModule,MatTabsModule,MatOption,MatOptionModule,MatSelectModule,MatDialogModule,MatFormFieldModule,MatInputModule, MatButtonModule,RouterModule
  ],
  templateUrl: './admin-page.component.html',
  styleUrl: './admin-page.component.css',
  providers:[FirebaseCrudService,MarriageMenuService],
  encapsulation: ViewEncapsulation.None
})
export class AdminPageComponent {

  
form = {
    text: '',
    type: '',
    image: '',
    tagline: '',
    itemcount: '',
    eventid: ''
  };

food={
  text:'',
  type:'',
  description:'',
  image:'',
  eventname:'',
  eventid:''

  
} 

menu = {
    foodtype:'', 
    foodtypeimage:'',
    foodtypetagline:'',
    foodname: '', 
    fooddesc: '',
    foodimage: '', 
    eventid:'',
    eventname: '',
    priceperplate: ''
  
}
newRow = {
          foodtype: '',
          foodtypeimage: '',
          foodtypetagline: '',
          foodname: '',
          fooddesc: '',
          foodimage: '',
          eventid: '',
          eventname: '',
          priceperplate: ''

        }

Lead={
  Name:'',
  Location:'',
  Phone:'',
  pax:'',
  date:'',
  event:'',
  menu:'',
  contacted:'',
  comments:'',
  requestdate:''

}
  success = false;
  error: string | null = null;
  foodTypeEvents: any[] =[];
  foodItems: any[] =[];
  foodmenu:any[]=[];
  foodmenubackup:any[]=[];
  leads:any[]=[];
  loading = true;
  masterfoodtype:any[]=[];
  editIndex: number | null = null;

// To save edited values (optional, but useful for two-way binding)
editedContacted: string = '';
editedComments: string = '';

  newFoodType = {
    order: 1,
    image: '',
    tagline: '',
    text: ''
  };
 newEvent = {
    EventId: '',
    EventName: ''
   
  };

  FoodType: any[] = [];
  events: any[] = [];
  eventsbackup: any[] = [];
  FoodTypeSuccess = false;
  FoodTypeError: string | null = null;
  public activeTab = 2;
  editRowIndex: number | null = null;
  editRow: any = {};

  filters = {
  requestDate: '',
  venue: '',
  event: '',
  contacted: ''
};

// The filtered list to be shown
filteredLeads: any[] = [];

  constructor(private crud: FirebaseCrudService,private marriagemenuService: MarriageMenuService,private dialog: MatDialog,private router: Router) {}
  

 subscription?: Subscription;

ngOnDestroy() {
  this.subscription?.unsubscribe();
}

  async ngOnInit() {

   const dialogRef = this.dialog.open(PasswordGuardDialogComponent, {
    disableClose: true,
    width: '320px'
  });

  const result = await firstValueFrom(dialogRef.afterClosed());
  if (!result) {
    // Not allowed, redirect or hide page
   // window.history.back();
    this.router.navigate(['./home']);
    dialogRef.close();
    return;
  }
  // else: show page as normal


    try {
      // This assumes your service provides a getDrinks() that returns an Observable
      const ftype$ = await this.crud.getFoodType();
        this.subscription = ftype$.subscribe({
          next: (data) => { this.FoodType = data; 
            this.sortAnyTable(this.FoodType, 'order');
          },
          error: (err) => { this.FoodTypeError = err?.message || 'Error loading drinks'; }
        });
    } catch (err: any) {
      this.FoodTypeError = err?.message || 'Error loading drinks';
    }

      try {
      // This assumes your service provides a getDrinks() that returns an Observable
      const event$ = await this.crud.getEvents();
        this.subscription = event$.subscribe({
          next: (data) => { this.events = data; 
            this.sortAnyTable(this.events, 'EventId');
          },
          error: (err) => { this.FoodTypeError = err?.message || 'Error loading events'; }
        });
    } catch (err: any) {
      this.FoodTypeError = err?.message || 'Error loading events';
    }


  try {
  const leads$ = await this.crud.getLeads(); // Await the promise to get the Observable
    this.subscription = leads$.subscribe({
      next: (data) => {
        //this.leads = data;
        this.leads = data.map(lead => ({
          ...lead,
          // Parse the menu string to an array if it's a string
          menu: typeof lead.menu === 'string' ? JSON.parse(lead.menu) : lead.menu,
          date: lead.date && lead.date.toDate ? lead.date.toDate() : lead.date
        }));
        this.loading = false;
        this.filteredLeads = this.leads;
      },
      error: (err) => {
        this.error = err?.message || 'Error loading data';
        this.loading = false;
      }
    });
  }
   catch (err: any) {
    this.error = err?.message || 'Error initializing data';
    this.loading = false;
  }

  try {
  const foodmenu$ = await this.crud.getFoodMenu(); // Await the promise to get the Observable
    this.subscription = foodmenu$.subscribe({
      next: (data) => {
        this.foodmenu = data;
        this.foodmenubackup = [...data]; // Create a backup of the original food menu
        this.loading = false;
      },
      error: (err) => {
        this.error = err?.message || 'Error loading data';
        this.loading = false;
      }
    });
  }
   catch (err: any) {
    this.error = err?.message || 'Error initializing data';
    this.loading = false;
  }


}

getHeaders(json: any[]): string[] {
  return json.length ? Object.keys(json[0]) : [];
}


  onFoodTypeChange(selectedValue: string) {
     // Backup the original food menu
     this.foodmenu = [...this.foodmenubackup];
    const foodType = this.FoodType.find(ft => ft.text === selectedValue);
    if (foodType) {
      this.newRow.foodtypetagline = foodType.tagline;
      this.newRow.foodtypeimage = foodType.image;
      this.foodmenu = this.foodmenu.filter((food) => food.foodtype === foodType.text);
    } else {
      this.newRow.foodtypetagline = '';
      this.newRow.foodtypeimage = '';
    }
  }

 


  // onSubmitFoodTypeByEvent() {
  //   this.success=false;
  //   this.crud.addFoodTypeByEvent(this.form)
  //     .then(() => {
  //       this.success = true;
  //       this.error = null;
  //       this.form = { text: '', type: '', image: '', tagline: '', itemcount: '', eventid: '' };
  //     })
  //     .catch(err => {
  //       this.error = err.message || 'Error adding entry';
  //       this.success = false;
  //     });
  // }



    onSubmitFoodItems() {
    this.success=false;
    this.crud.addFoodItems(this.food)
      .then(() => {
        this.success = true;
        this.error = null;
        this.food = { text: '', type: '', description: '', image: '', eventname: '', eventid: '' };
       

      })
      .catch(err => {
        this.error = err.message || 'Error adding entry';
        this.success = false;
      });
  }


    onSubmitFoodMenu() {
    this.success=false;
    this.crud.addFoodMenu(this.newRow)
      .then(() => {
        this.success = true;
        this.error = null;
        this.menu = {
          foodtype: '',
          foodtypeimage: '',
          foodtypetagline: '',
          foodname: '',
          fooddesc: '',
          foodimage: '',
          eventid: '',
          eventname: '',
          priceperplate: ''

        }
       
      })
      .catch(err => {
        this.error = err.message || 'Error adding entry';
        this.success = false;
      });
  }

   isNewRowValid() {
    return !!this.newRow.foodname && !!this.newRow.foodtype && !!this.newRow.eventname;
  }


  async deleteFoodType(item: any) {
     if (!confirm("Are you sure you want to delete the Food Type named " + item.text+" ? This action cannot be undone.")) {
      return; // User cancelled the deletion   
    }
    this.success = false;
    const id = item.id;
    if (!id) {
      this.error = "Cannot delete: item has no ID.";
      return;
    }
    try {
      await this.crud.deleteFoodTypeByEvent(id);
      this.foodTypeEvents = this.foodTypeEvents.filter(e => e.id !== id);
      this.success = true;
    } catch (err: any) {
      this.error = err?.message || "Failed to delete entry.";
    }
  }



 async deleteFoodItem(item: any) {
  
    if (!confirm("Are you sure you want to delete this item? This action cannot be undone.")) {
      return; // User cancelled the deletion   
    }
  this.success = false;
    const id = item.id;
    if (!id) {
      this.error = "Cannot delete: item has no ID.";
      return;
    }
    try {
      await this.crud.deleteFoodItems(id);
      this.foodItems = this.foodItems.filter(e => e.id !== id);
      this.success = true;
    } catch (err: any) {
      this.error = err?.message || "Failed to delete entry.";
    }
  }

EditLead(item: any, index: number) {
  this.editIndex = index;
  this.editedContacted = item.contacted;
  this.editedComments = item.comments;
  this.editRow = { ...item }; // Create a copy of the item to edit
}
async SaveLead(item: any, index: number) {
  // Update the item with edited values
  item.contacted = this.editedContacted;
  item.comments = this.editedComments;
  this.editRow.contacted = this.editedContacted;
  this.editRow.comments = this.editedComments;
  const updatedItem = { ...this.editRow };
  this.editIndex = null;
  this.crud.updateLeads(item.id, updatedItem).then(() => {
      // Update local array only if API call succeeds
      this.leads[item.index] = updatedItem;
      this.editRow = {};
      this.success = true;
      // Optionally, show a notification or refresh data
    }).catch(err => {
      this.error = "Failed to update item: " + err.message;
    });
  // Optionally, call API to persist changes here
}

CancelEdit() {
  this.editIndex = null;
}



sortColumn: string = '';
sortDirection: 'asc' | 'desc' = 'asc';

sortTable(column: string) {
  if (this.sortColumn === column) {
    // Toggle direction if the same column is clicked
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  } else {
    this.sortColumn = column;
    this.sortDirection = 'asc';
  }

  this.foodmenu.sort((a, b) => {
    let valA = a[column];
    let valB = b[column];

    // Handle numbers
    if (typeof valA === 'number' && typeof valB === 'number') {
      return this.sortDirection === 'asc' ? valA - valB : valB - valA;
    }

    // Handle string (and fallback)
    valA = valA ? valA.toString().toLowerCase() : '';
    valB = valB ? valB.toString().toLowerCase() : '';
    if (valA < valB) return this.sortDirection === 'asc' ? -1 : 1;
    if (valA > valB) return this.sortDirection === 'asc' ? 1 : -1;
    return 0;
  });
}

sortAnyTable(collection:any[],column: string) {
  if (this.sortColumn === column) {
    // Toggle direction if the same column is clicked
    this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
  } else {
    this.sortColumn = column;
    this.sortDirection = 'asc';
  }

  collection.sort((a, b) => {
    let valA = a[column];
    let valB = b[column];

    // Handle numbers
    if (typeof valA === 'number' && typeof valB === 'number') {
      return this.sortDirection === 'asc' ? valA - valB : valB - valA;
    }

    // Handle string (and fallback)
    valA = valA ? valA.toString().toLowerCase() : '';
    valB = valB ? valB.toString().toLowerCase() : '';
    if (valA < valB) return this.sortDirection === 'asc' ? -1 : 1;
    if (valA > valB) return this.sortDirection === 'asc' ? 1 : -1;
    return 0;
  });
}



  startEditRow(index: number) {
  this.editRowIndex = index;
  // Deep copy of the row so editing doesn't change until Save
  this.editRow = { ...this.foodmenu[index] };
}

async saveMenuItem(item: any) {
    // Persist changes to backend (FirebaseCrudService)
  
    const updatedItem = { ...this.editRow };
    const id = updatedItem.id; // Make sure your items have an 'id' field
    this.crud.updateFoodMenu(id, updatedItem).then(() => {
      // Update local array only if API call succeeds
      this.foodmenu[item.index] = updatedItem;
      this.editRowIndex = null;
      this.editRow = {};
      this.success = true;
      // Optionally, show a notification or refresh data
    }).catch(err => {
      this.error = "Failed to update item: " + err.message;
    });

  
}


cancelEditRow() {
  this.editRowIndex = null;
  this.editRow = {};
}
onEditFoodTypeChange(selectedType: string, index: number) {
  // If you want to autopopulate tagline/image as in the add row
  const typeObj = this.FoodType.find(t => t.text === selectedType);
  if (typeObj) {
    this.editRow.foodtypetagline = typeObj.tagline;
    this.editRow.foodtypeimage = typeObj.image;
  }
}




  async onSubmitFoodType() {
    this.FoodTypeSuccess = false;
    this.FoodTypeError = null;
    try {
      // Save to Firestore (collection: 'drinks'), add your service method as needed
      // Example with AngularFire modular SDK:
      // await addDoc(collection(this.firestore, 'drinks'), this.newDrink);
      // Or, if you have a service method like this.crud.addDrink:
      await this.crud.addFoodType(this.newFoodType);
      this.FoodTypeSuccess = true;
      this.newFoodType = { order: 1, image: '', tagline: '', text: '' };
      // Optionally refresh drinks list here if you fetch from backend
    } catch (err: any) {
      this.FoodTypeError = err?.message || 'Error adding drink';
    }
  }

  saveFTEdit(i: number) {
  // Copy edited values back to the original array
  this.FoodType[i] = { ...this.editRow };
  this.crud.updateFoodType(this.FoodType[i].id, this.FoodType[i])
    .then(() => {
      this.success = true;
      this.error = null;
      this.editIndex = null; // Exit edit mode
      this.editRow = {}; // Clear the edit row
    })
    .catch(err => {
      this.error = err.message || 'Error updating food type';
      this.success = false;
    });
  // Exit edit mode
  
}

  editFoodType(i: number, foodType: any) {
    this.editIndex = i;
    this.editRow = { ...foodType }; // Clone to avoid direct mutation
  }

  cancelEditFT() {
    this.editIndex = null;
    this.editRow = {};
  }

  get imageOptions(): string[] {
    // Filter out duplicates and empty/null values
    return Array.from(new Set(this.FoodType.map(ft => ft.image).filter(Boolean)));
  }

   async onSubmitEvent() {
    this.FoodTypeSuccess = false;
    this.FoodTypeError = null;
    try {
      // Save to Firestore (collection: 'drinks'), add your service method as needed
      // Example with AngularFire modular SDK:
      // await addDoc(collection(this.firestore, 'drinks'), this.newDrink);
      // Or, if you have a service method like this.crud.addDrink:
      await this.crud.addEvent(this.newEvent);
      this.FoodTypeSuccess = true;
      this.newEvent = { EventId: '', EventName: '' };
      // Optionally refresh drinks list here if you fetch from backend
    } catch (err: any) {
      this.FoodTypeError = err?.message || 'Error adding drink';
    }
  }
 async deleteEvent(item: any) {
 
    if (!confirm("Are you sure you want to delete this item? This action cannot be undone.")) {
      return; // User cancelled the deletion   
    }
  this.success = false;
    const id = item.id;
    if (!id) {
      this.error = "Cannot delete: item has no ID.";
      return;
    }
    try {
      await this.crud.deleteEvent(id);
      this.events = this.events.filter(e => e.id !== id);
      this.success = true;
    } catch (err: any) {
      this.error = err?.message || "Failed to delete entry.";
    }
  }




  onEventChange(selectedType: string, index: number) {
  // If you want to autopopulate tagline/image as in the add row
  const typeObj = this.events.find(t => t.EventName === selectedType);
  if (typeObj) {
    this.editRow.eventName = typeObj.EventName;
    this.editRow.eventid = typeObj.EventId;
  }
}


toDDMMYYYY(dateString: string): string {
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return ''; // Invalid date
  const dd = String(date.getDate()).padStart(2, '0');
  const mm = String(date.getMonth() + 1).padStart(2, '0');
  const yyyy = date.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
}

applyFilters() {
  this.filteredLeads = this.leads.filter(item => {
    // Filter Request Date (date input gives 'yyyy-mm-dd')
    let matchesRequestDate = true;
    if (this.filters.requestDate) {
      const itemDate = new Date(item.requestdate);
      const filterDate = new Date(this.filters.requestDate);
      matchesRequestDate =
        itemDate.getFullYear() === filterDate.getFullYear() &&
        itemDate.getMonth() === filterDate.getMonth() &&
        itemDate.getDate() === filterDate.getDate();
    }

    // Filter Venue (case-insensitive substring)
    let matchesVenue = true;
    if (this.filters.venue) {
      matchesVenue = item.Location && item.Location.toLowerCase().includes(this.filters.venue.toLowerCase());
    }

    // Filter Event (case-insensitive substring)
    let matchesEvent = true;
    if (this.filters.event) {
      matchesEvent = item.event && item.event.toLowerCase().includes(this.filters.event.toLowerCase());
    }

    // Filter Contacted
    let matchesContacted = true;
    if (this.filters.contacted) {
      matchesContacted = item.contacted && item.contacted.toLowerCase() === this.filters.contacted.toLowerCase();
    }

    return matchesRequestDate && matchesVenue && matchesEvent && matchesContacted;
  });
}

editEventIndex: number | null = null;
editEventModel: any = {};

editEvent(i: number) {
  this.editEventIndex = i;
  // Shallow copy to avoid two-way binding until "Save"
  this.editEventModel = { ...this.events[i] };
}

saveEdit(i: number) {
  // Commit the changes
  this.events[i] = { ...this.editEventModel };
  this.editEventIndex = null;
  this.crud.updateEvent(this.editEventModel.id, this.editEventModel)
    .then(() => {
      this.success = true;
      this.error = null;
    })
    .catch(err => {
      this.error = err.message || 'Error updating event';
      this.success = false;
    });
}

cancelEdit() {
  this.editEventIndex = null;
}

}



